import { QrGen } from "./class/QRGen";
import { drawQRCanvas } from "./drawing/draw";
import { cornerTest } from "./cornerDev";
import say from "./say";

export {
    QrGen, say,
    drawQRCanvas,
    cornerTest,
};
